<template>
  <div class="table-responsive">
    <table class="table custom-table mb-0" v-if="AdminClients.length > 0">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th class="text-end">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in AdminClients" :key="item.id">
          <td>
            <h2 class="table-avatar">
              <router-link to="client-profile">
                {{ item?.first_name }} {{ item?.last_name }}
                <span>{{ item.Role }}</span></router-link
              >
            </h2>
          </td>
          <td>{{ item.email }}</td>
          <td class="text-end">
            <div class="dropdown dropdown-action">
              <a
                href="javascript:;"
                class="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                ><i class="material-icons">more_vert</i></a
              >
              <div class="dropdown-menu dropdown-menu-right">
                <router-link
                  class="dropdown-item"
                  :to="'clientprofile/' + item?.id"
                  ><i class="fa-solid fa-eye m-r-5"></i> View</router-link
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="p-2 text-center">
      <div class="ant-empty-image">
        <svg
          width="64"
          height="41"
          viewBox="0 0 64 41"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
            <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fill-rule="nonzero" stroke="#d9d9d9">
              <path
                d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
              ></path>
              <path
                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                fill="#fafafa"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <p style="color: #00000040; margin-bottom: 0px">No data</p>
    </div>
  </div>
</template>

<script>
import AdminClients from "@/assets/json/admin-clients.json";
import { notification } from "ant-design-vue";
import axios from "axios";

export default {
  data() {
    return {
      AdminClients: [],
    };
  },
  methods: {
    loadClients() {
      const token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/client", { params: { per_page: 3 } }) // Fetch only 3 clients
        .then((response) => {
          // console.log(response.data.data.record.data.slice(0, 3));
          console.log(response.data);
          const records = response.data?.data?.record?.data;
          this.AdminClients = Array.isArray(records) ? records.slice(0, 3) : [];
        })
        .catch((error) => {
          var response = error.response;
          console.log(error);

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    this.loadClients(); // Call the method without arguments
  },
};
</script>
